const ITEMS = [
    "Strategy",
    "Sustainability",
    "ESG",
    "Governance",
    "Compliance",
    "Organisational Performance",
];

const Copy = ({ hidden }) => (
    <div
        className="flex items-center"
        aria-hidden={hidden ? "true" : undefined}
    >
        {ITEMS.map((it) => (
            <span key={it} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif-d text-2xl italic text-ink/70 md:px-12 md:text-3xl">
                    {it}
                </span>
                <span className="h-2 w-2 shrink-0 bg-brand" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            className="marquee-band overflow-hidden border-y border-black/10 bg-paper py-6 md:py-8"
            data-testid="practice-areas-marquee"
        >
            <div className="marquee-track flex w-max">
                <Copy />
                <Copy hidden />
            </div>
        </div>
    );
}
